import { render, staticRenderFns } from "./footerNew.vue?vue&type=template&id=80c6efa6&scoped=true"
import script from "./footerNew.vue?vue&type=script&lang=js"
export * from "./footerNew.vue?vue&type=script&lang=js"
import style0 from "./footerNew.vue?vue&type=style&index=0&id=80c6efa6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80c6efa6",
  null
  
)

export default component.exports